import createIcon from '../../createIcon';

/**
 * @component @name Lyrics
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOS41QzEzIDcuNDYgMTQuMjQgNS43MSAxNiA0LjkzVjQuNUMxNiAzLjQgMTUuMSAyLjUgMTQgMi41SDNDMS45IDIuNSAxLjAxIDMuNCAxLjAxIDQuNUwxIDIyLjVMNSAxOC41SDE0QzE1LjEgMTguNSAxNiAxNy42IDE2IDE2LjVWMTQuMDhDMTQuMjQgMTMuMyAxMyAxMS41NSAxMyA5LjVaTTkgMTQuNUg1VjEyLjVIOVYxNC41Wk0xMiAxMS41SDVWOS41SDEyVjExLjVaTTEyIDguNUg1VjYuNUgxMlY4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkgNi42OEMxOC42OSA2LjU3IDE4LjM1IDYuNSAxOCA2LjVDMTYuMzQgNi41IDE1IDcuODQgMTUgOS41QzE1IDExLjE2IDE2LjM0IDEyLjUgMTggMTIuNUMxOS42NiAxMi41IDIxIDExLjE2IDIxIDkuNVYzLjVIMjNWMS41SDE5VjYuNjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Lyrics = createIcon('Lyrics', [
  [
    'path',
    {
      d: 'M13 9.5C13 7.46 14.24 5.71 16 4.93V4.5C16 3.4 15.1 2.5 14 2.5H3C1.9 2.5 1.01 3.4 1.01 4.5L1 22.5L5 18.5H14C15.1 18.5 16 17.6 16 16.5V14.08C14.24 13.3 13 11.55 13 9.5ZM9 14.5H5V12.5H9V14.5ZM12 11.5H5V9.5H12V11.5ZM12 8.5H5V6.5H12V8.5Z',
      key: 'voukzk',
    },
  ],
  [
    'path',
    {
      d: 'M19 6.68C18.69 6.57 18.35 6.5 18 6.5C16.34 6.5 15 7.84 15 9.5C15 11.16 16.34 12.5 18 12.5C19.66 12.5 21 11.16 21 9.5V3.5H23V1.5H19V6.68Z',
      key: '1c8dkz',
    },
  ],
]);

export default Lyrics;
